/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Routemize_DTOs_AssignBookingUser } from '../models/Routemize_DTOs_AssignBookingUser';
import type { Routemize_DTOs_BookingFormUserDto } from '../models/Routemize_DTOs_BookingFormUserDto';
import type { Routemize_DTOs_UserSmallDTO } from '../models/Routemize_DTOs_UserSmallDTO';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class BookingFormUserService {
    /**
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static postApiAppBookingFormUserCreateMany(
        requestBody?: Routemize_DTOs_AssignBookingUser,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/bookingFormUser/createMany',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param id
     * @returns any OK
     * @throws ApiError
     */
    public static deleteApiAppBookingFormUserDelete(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/app/bookingFormUser/{id}/delete',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param formId
     * @returns Routemize_DTOs_UserSmallDTO OK
     * @throws ApiError
     */
    public static getApiAppBookingFormUserGetFormUsers(
        formId: string,
    ): CancelablePromise<Array<Routemize_DTOs_UserSmallDTO>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/bookingFormUser/getFormUsers/{formId}',
            path: {
                'formId': formId,
            },
        });
    }
    /**
     * @param formId
     * @returns Routemize_DTOs_BookingFormUserDto OK
     * @throws ApiError
     */
    public static getApiAppBookingFormUserGetAssignedUsers(
        formId: string,
    ): CancelablePromise<Array<Routemize_DTOs_BookingFormUserDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/bookingFormUser/getAssignedUsers/{formId}',
            path: {
                'formId': formId,
            },
        });
    }
}
